<template>
  <div id="app">
    <socket-status />
    <div id="nav" class="container d-print-none" v-if="isLoggedIn && $route.name !== 'remote'">
      {{ selectedPlayerId }} [
      <span v-for="(item, index) in navItems" :key="index">
        <router-link :to="item.to">{{ item.label }}</router-link> |
      </span>
      <template v-if="!$store.state.user.name">
        <a href="#" @click.stop.prevent="logOut">Disconnect</a>
      </template>
      <template v-else>
        {{ $store.state.user.name }} - <a href="/.auth/logout">Log out</a>
      </template>
      ]
      <hr/>
    </div>

    <router-view v-if="isLoggedIn"/>
    <div class="d-print-none" id="footer"><div class="container small">{{ $store.state.packageName }} v.{{ $store.state.packageVersion }} {{ $store.state.gitHash }}</div></div>
  </div>
</template>

<script>
import 'rph-slides-vue/src/styles/app.scss'
import '@/styles/app.scss'

// import { mapState } from 'vuex'
import { tokenMixin } from 'rph-slides-vue/src/mixins/tokenMixin.js'
import { SLIDES_NAMESPACE, SET_SELECTED_PLAYER_ID } from 'rph-slides-vue/src/store/slides.mutation-types.js'
import { AUTH_NAMESPACE } from 'rph-slides-vue/src/store/auth.mutation-types.js'
// import SocketStatus from '@/components/SocketStatus.vue'
import SocketStatus from 'rph-slides-vue/src/components/SocketStatus.vue'

export default {
  name: 'app',
  components: {
    SocketStatus
  },
  mixins: [tokenMixin],
  // data () { return {} },
  computed: {
    selectedPlayerId: {
      get () {
        return this.$store.state[SLIDES_NAMESPACE].selectedPlayerId
      },
      set (id) {
        this.$store.commit(SLIDES_NAMESPACE + '/' + SET_SELECTED_PLAYER_ID, id)
      }
    },
    navItems () {
      return this.$store.state.nav.items
    },
    isLoggedIn () {
      return this.$store.state.socketConnected
    }
    // ...mapGetters(AUTH_NAMESPACE, ['isLoggedIn']),
    // ...mapState(AUTH_NAMESPACE, ['token'])
  },
  created () {
    // this.$socket.emit('/config/players', this.tokenize(), (response) => {
    //   // console.log('/config/players', response)
    //   if (response.status.code === 200) {
    //     if (this.selectedRendererId === 'default') this.selectedRendererId = response.data.selectedRendererId
    //     if (this.selectedPlayerId === 'default') this.selectedPlayerId = response.data.selectedPlayerId
    //   } else {
    //     // console.log('/config/players', response)
    //   }
    // })
    this.$socket.on('/players/status', this.onStatusUpdate)
    // this.$socket.on('/logs', response => {
    //   console.log(response)
    // })
  },
  methods: {
    onStatusUpdate ({ data }) {
      this.$store.commit('setSlideStatusDetails', data)
    },
    logOut () {
      this.$store.dispatch(AUTH_NAMESPACE + '/logOut')
    }
  }
}
</script>
